import { computed } from 'vue';

import { usePreviousInsuranceStore } from '@/features/PreviousInsurance/store';
import { useResContractStore } from '@/features/Sparten/res/useContractStore';
import { useResInputStore } from '@/features/Sparten/res/useInputStore';

export const hasNoPreviousInsurance = computed(
  () => !usePreviousInsuranceStore().hasPreviousInsurance,
);

export const hasPreviousInsuranceFromPartner = computed(
  () =>
    useResContractStore().zusaetzlicheAngaben.allgemein.vorversicherungPartner
      .enabled,
);

export const hasPreviousInsuranceVorversicherungVersicherungsnehmer = computed(
  () =>
    hasNoPreviousInsurance.value &&
    useResContractStore().zusaetzlicheAngaben.allgemein
      .vorversicherungVersicherungsnehmer.enabled,
);

export const hasRentCoverage = computed(
  () => useResInputStore().leistungsumfang.mieten,
);

export const hasRentalCoverage = computed(
  () => useResInputStore().leistungsumfang.vermietung,
);

export const hasAtLeastTwoRentals = computed(
  () =>
    hasRentalCoverage.value &&
    (useResInputStore().leistungsumfang.vermietungObjekteAnzahl?.length ?? 0) >=
      2,
);

export const hasThreeRentals = computed(
  () =>
    hasRentalCoverage.value &&
    useResInputStore().leistungsumfang.vermietungObjekteAnzahl?.length === 3,
);

export const hasTrafficCoverage = computed(
  () => useResInputStore().leistungsumfang.verkehr,
);

export const hasAtLeastVehicles = (
  min: number,
  mustHaveMultipleVehicles = true,
): boolean =>
  useResInputStore().leistungsumfang.verkehr &&
  (mustHaveMultipleVehicles
    ? useResInputStore().leistungsumfang.hasMehrereFahrzeuge &&
      useResInputStore().leistungsumfang.anzahlFahrzeuge >= min
    : true);

export const hasLeistungsumfangPrivat = computed(
  () => useResInputStore().leistungsumfang.privat,
);

export const hasLeistungsumfangVerkehr = computed(
  () => useResInputStore().leistungsumfang.verkehr,
);

export const hasLeistungsumfangWithManyVehicles = computed(
  () =>
    hasLeistungsumfangVerkehr.value &&
    useResInputStore().leistungsumfang.hasMehrereFahrzeuge,
);

export const hasLeistungsumfangMieten = computed(
  () => useResInputStore().leistungsumfang.vermietung,
);
